import React from 'react';

// ! Components
import { BoxCellVertical } from './BoxCellVertical';
import { QuantityAvailableCellRenderer } from './QuantityAvailableCellRenderer';
import { UnitPriceCellRenderer } from './UnitPriceCellRenderer';
import { DKPartNumberCellRenderer } from './DKPartNumberCellRenderer';
import { PackageTypeCellRenderer } from './PackageTypeCellRenderer';
import { PartNumberCellRendererVerticalViewCellRenderer } from './PartNumberCellRendererVerticalViewCellRenderer';
import { RohsIcon } from './RohsIcon';
import { DatasheetIcon } from './DatasheetIcon';
import { Supplier } from '../supplier';
import { MrfPart } from '../mrf-part';
import './CustomColumnDataCellRenderer.scss';
import { UnitPriceTariffCellRenderer } from './UnitPriceTariffCellRender';

export const CustomColumnDataCellRenderer: React.FC = (props: any) => {
  const { data, colDef } = props;

  if (colDef.field === 'checkBoxColumn') {
    return (
      <div style={{ textAlign: 'center' }}>
        <BoxCellVertical data={data} />
      </div>
    );
  }

  if (data.secondColumn) {
    switch (data.fieldMapping) {
      // ! COLUMN Mfr Part
      case 'manufacturerProductNumber':
        return data.isCompacted ? (
          <div className= {`${data.isComparePage ? 'compare-page' : 'render-container'}`}>
            <MrfPart data={data.sourceData} />
          </div>
        ) : (
          <PartNumberCellRendererVerticalViewCellRenderer
            data={data.sourceData}
          />
        );
  
      // ! COLUMN Unit Price
      case 'unitPrice':
        return (
          <div className= {`${data.isComparePage ? 'compare-page' : 'render-container'}`}>
            <UnitPriceCellRenderer
              {...{ data: data.sourceData, children: null }}
            />
          </div>
        );

        // ! COLUMN Unit Price Tariff
      case 'priceBreaksIncludeTariff':
        return (
          <div className= {`${data.isComparePage ? 'compare-page' : 'render-container'}`}>
            <UnitPriceTariffCellRenderer
              {...{ data: data.sourceData, children: null }}
            />
          </div>
        );
  
      // ! COLUMN Digikey PartNumber
      case 'digikeyPartNumber':
        return (
          <div className= {`${data.isComparePage ? 'compare-page' : 'render-container'}`}>
            <DKPartNumberCellRenderer
              {...{ data: data.sourceData, children: null }}
            />
          </div>
        );
  
      // ! COLUMN Quantity Available
      case 'quantityAvailable':
        return (
          <div className= {`${data.isComparePage ? 'compare-page' : 'render-container'}`}>
            <QuantityAvailableCellRenderer
              {...{ data: data.sourceData, children: null }}
            />
          </div>
        );
  
      // ! COLUMN Package Type
      case 'packageTypeCellRenderer':
        return (
          <div className= {`${data.isComparePage ? 'compare-page' : 'render-container'}`}>
            <PackageTypeCellRenderer
              {...{ data: data.sourceData, children: null }}
            />
          </div>
        );
  
      // ! COLUMN Supplier
      case 'supplier':
        return (
          <div className= {`${data.isComparePage ? 'compare-page' : 'render-container'}`}>
            <Supplier data={data.sourceData} />
          </div>
        );
  
      // ! COLUMN RohsIcon
      case 'rohsStatus':
        return (
          <div className= {`${data.isComparePage ? 'compare-page' : 'render-container'}`}>
            <RohsIcon rohsStatus={data.secondColumn[data.fieldMapping]} />
          </div>
        );
  
      // ! COLUMN Datasheet
      case 'primaryDatasheetUrl':
        return (
          <div className= {`${data.isComparePage ? 'compare-page' : 'render-container'}`}>
            {data.secondColumn[data.fieldMapping] && (
              <DatasheetIcon
                primaryDatasheetUrl={data.secondColumn[data.fieldMapping]}
              />
            )}
          </div>
        );
  
      // ! Another column
      default:
        return (
          <div className= {`${data.isComparePage ? 'compare-page' : 'render-container'}`}>
            {data.secondColumn[data.fieldMapping]}
          </div>
        );
    }
  }

  return <></>;
};
